
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import CircleProgressBar from './progress/CircleProgressBar.vue';
import Constants from '../settings/ui';

export default Vue.extend({
  components: {
    Icon,
    CircleProgressBar,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      green: Constants.colorPalette.green,
    };
  },
});
